import { Route, Routes } from 'react-router';

import PostEdit from './PostEdit';
import PostsList from './PostsList';
import ReportedPostEdit from './ReportedPostEdit';
import ReportedPostsList from './ReportedPostsList';

function PostModule() {
  return (
    <Routes>
      <Route path="" element={<PostsList />} />
      <Route path=":id" element={<PostEdit />} />
      <Route path="reported" element={<ReportedPostsList />} />
      <Route path="reported/:id" element={<ReportedPostEdit />} />
    </Routes>
  );
}

export default PostModule;
